import Breadcrumbs from "../components/Breadcrumbs";
import AvailableTimeSlotsCard from "../components/events/AvailableTimeSlotsCard";
import RecentlyCompletedSessionCard from "../components/recently-completed-session-card/RecentlyCompletedSessionCard";
import UpcomingSessionsCard from "../components/upcoming-session-card/UpcomingSessionsCard";
import LeftMenu from "../components/LeftMenu";

const HomePage = () => {
  return (
    <div className="flex h-full gap-4">
      {/* Left Side */}
      <LeftMenu />
      <div className="w-full p-4 pb-10 lg:px-10">
        <div className="lg:max-w-[694px]">
          <Breadcrumbs />
          <div className="space-y-4 py-6 lg:space-y-6">
            <h1>Welcome Back, #InstructorName</h1>
            <UpcomingSessionsCard />
            <RecentlyCompletedSessionCard />
            <AvailableTimeSlotsCard />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
